import { ca } from '@cian/analytics';

import { TActionPlacement } from '../../types/analytics';

export type TSellerType = 'builders' | 'agents';

interface ITrackShowPhone {
  newbuildingId: number;
  url: string;
  sellerType?: TSellerType;
  placement: TActionPlacement;
}

export function trackShowPhone({ newbuildingId, url, sellerType, placement }: ITrackShowPhone) {
  const isGallery = placement === 'gallery';
  const sellerTypeExtra = sellerType ? { seller_type: sellerType } : {};

  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: isGallery ? 'Open_compare_jk_gallery' : 'Open_compare_jk_listing',
    label: url,
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: {
      extra: isGallery ? sellerTypeExtra : { compare_type: 'newbuildings', ...sellerTypeExtra },
    },
  });
}

interface ITrackOpenContacts {
  newbuildingId: number;
  url: string;
}

export function trackOpenContacts({ newbuildingId, url }: ITrackOpenContacts) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'open_contacts',
    label: url,
    products: [{ id: newbuildingId, offerType: 'JK' }],
  });
}
